<template>

    <div>
        There was a problem logging out.
    </div>

</template>



<script>

	export default {

	    name: 'logout'
	    
	}

</script>



<style lang="scss">

	@import "../variables";

</style>



// WEBPACK FOOTER //
// Logout.vue?d6203aa8